import {
  Box,
  Card,
  CardContent,
  Grid,
  Grid2,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useTheme
} from '@mui/material';
import StatCard from '../../components/StatCard';
import HighlightedCard from '../../components/HighlightedCard';
import { Gauge, gaugeClasses, LineChart, BarChart } from '@mui/x-charts';
import TeaserDashboard from '../../components/TeaserDashboard';
import { useAuth } from '../../AuthContext';
import ShotDashboard from '../../components/ShotDashboard';

export default function ShotData() {
  const auth = useAuth();

  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      <ShotDashboard />
      {/* {auth.user.stripe?.activeProSubscription ? (
        <ShotDashboard />
      ) : (
        <TeaserDashboard />
      )} */}
    </Box>
  );
}